import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "../lib/api";

export function usePageTracker() {
  const location = useLocation();

  useEffect(() => {
    const page = location.pathname || "/";
    api.post("/track/pageview", { page }).catch(() => {});
  }, [location.pathname]);
}
